import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    GetStripePaymentIntent,
} from "client/store"
import { CrossIcon } from "client/components"
import {
    BillingModalWrapper,
    CloseButton,
    BillingModalContentWrapper,
    BillingModalTitle,
} from "./styled"

interface CompletePaymentProps {
    show: boolean
    onClose: () => void
}

const CompletePayment = ({
    show,
    onClose,
}: CompletePaymentProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const [message, setMessage] = useState(null)

    useEffect(() => {
        const paymentIntentId = new URLSearchParams(window.location.search).get("payment_intent")
        if (!paymentIntentId) return
        // all data are copied with a webhook on server side:
        // action "completePaymentWebhook" at src\server\routers\stripe.ts

        GetStripePaymentIntent(paymentIntentId)
        .then((paymentIntent) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage(lang.paymentSucceeded)
                    break
                case "processing":
                    setMessage(lang.paymentProcessing)
                    break
                case "requires_payment_method":
                    setMessage(lang.paymentRequiresPaymentMethod)
                    break
                default:
                    setMessage(lang.paymentDefault)
                    break
            }
        })
    }, [])

    return (
        <BillingModalWrapper show={show}>
            <CloseButton onClick={onClose}>
                <CrossIcon />
            </CloseButton>
            <BillingModalContentWrapper>
                {
                    message
                    && <BillingModalTitle>{message}</BillingModalTitle>
                }
            </BillingModalContentWrapper>
        </BillingModalWrapper>
    )
}
export default CompletePayment
